module.exports = __webpack_public_path__ + "img/star.91c10562.svg";